import { render, staticRenderFns } from "./MyInfo.vue?vue&type=template&id=a720d300&scoped=true&"
import script from "./MyInfo.vue?vue&type=script&lang=js&"
export * from "./MyInfo.vue?vue&type=script&lang=js&"
import style0 from "./MyInfo.vue?vue&type=style&index=0&id=a720d300&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a720d300",
  null
  
)

export default component.exports